import { TeamMemberTypeRoleEnum } from '@/graphql';

import { MAX_TEAM_NAME_LENGTH } from './constants';

function getUserRoleTitle(role: TeamMemberTypeRoleEnum) {
  if (role === TeamMemberTypeRoleEnum.Admin) return 'Admin';
  if (role === TeamMemberTypeRoleEnum.TeamAdmin) return 'Team admin';
  if (role === TeamMemberTypeRoleEnum.TeamMember) return 'Team member';
}

function getTeamNameErrors(name: string) {
  const errors = [];
  if (name.length > MAX_TEAM_NAME_LENGTH) {
    errors.push(`Team name should be less than or equal to ${MAX_TEAM_NAME_LENGTH} characters`);
  }
  return errors;
}

export { getUserRoleTitle, getTeamNameErrors };
